import {request} from 'api';
import {Query} from 'models/api';
import {LocaleData} from 'contexts/LocaleContext';

import {getEventsByService} from 'components/Community/Events/api';
import {DataSource, LoadableData} from 'units/constructor-local/models';
import {getBlogPostsByService} from 'units/blog/api';
import {getServicesBySolution} from 'units/solutions/api';

export interface GetPageParams {
    page: string;
    params?: Query;
}

export interface FetchDataParams {
    locale: LocaleData;
    serviceId?: number;
    solutionId?: number;
}

export function getPage<TResponse>({lang, region}: LocaleData, {page, params}: GetPageParams) {
    return request<TResponse>({
        method: 'GET',
        url: `/api/constructor/${page}`,
        params: {...params, lang, region},
    });
}

export async function fetchData(
    params: FetchDataParams,
    source: DataSource,
): Promise<LoadableData> {
    const {locale, serviceId, solutionId} = params;

    switch (source) {
        case DataSource.Events: {
            const data = await getEventsByService(locale, serviceId);
            return data && data.events;
        }

        case DataSource.Blog: {
            return await getBlogPostsByService(locale, serviceId);
        }

        case DataSource.Services: {
            return solutionId ? await getServicesBySolution(locale, solutionId) : undefined;
        }

        default:
            throw new Error(`PAGE_CONSTRUCTOR_ERROR unknown data source ${source}`);
    }
}
